/**
 * 課題の一覧の URL の条件（検索語 `q`・テーマ `theme`・CS向け表示 `cs=true`・隠したものも出す `hidden=true`）。
 *
 * 絞り込みを URL に入れ、同じ URL を開けば同じ一覧になるようにする（要件 D16）。
 *
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 課題の一覧の検索語・テーマ・CS向け表示・隠したものの表示を URL の条件として読み書きする
 * @graph-connects none
 */

/**
 * 課題の一覧の条件。
 * @graph-connects none
 */
export interface IssueListSearch {
  q: string;
  theme: string | null;
  cs: boolean;
  hidden: boolean;
}

/**
 * URL の条件を読む（知らない値・形の違う値は無いものとして扱う）。
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 課題の一覧の URL の条件を読み、検索語・テーマ・CS向け表示・隠したものの表示にする
 * @graph-connects none
 */
export function parseIssueListSearch(search: Record<string, unknown>): IssueListSearch {
  const flag = (value: unknown) => value === '1' || value === 1 || value === true;
  return {
    q: typeof search.q === 'string' ? search.q : '',
    theme: typeof search.theme === 'string' && search.theme !== '' ? search.theme : null,
    cs: flag(search.cs),
    hidden: flag(search.hidden),
  };
}

/**
 * 条件を URL に書く形にする（既定の値は書かない）。
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 課題の一覧の条件を、既定の値を省いた URL の条件にする
 * @graph-connects none
 */
export function toIssueListSearchParams(search: IssueListSearch): Record<string, string | boolean> {
  return {
    ...(search.q === '' ? {} : { q: search.q }),
    ...(search.theme === null ? {} : { theme: search.theme }),
    ...(search.cs ? { cs: true } : {}),
    ...(search.hidden ? { hidden: true } : {}),
  };
}
